import React from "react";
import { default as MuiLinearProgress } from "@mui/material/LinearProgress";

function LinearProgress(props) {
  return <MuiLinearProgress {...props} />;
}

export default LinearProgress;
